import PropTypes from "prop-types"
import styled from "styled-components"

const StyledAttributeMeta = styled.div`
  text-transform: ${(props) => props.textTransform};
  font-size: 14px;
  font-family: ${({ theme }) => theme.fontFamily.geberitRg};
  font-weight: 500;
`

const AttributeMeta = ({ text, textTransform = "none" }) => {
  return <StyledAttributeMeta textTransform={textTransform}>{text}</StyledAttributeMeta>
}

export default AttributeMeta

AttributeMeta.propTypes = {
  text: PropTypes.string,
  textTransform: PropTypes.oneOf(["none", "capitalize", "lowercase", "uppercase"]),
}
